import React from 'react';

interface HTMLContentRendererProps {
  payload: {
    html: string;
  };
}

export const HTMLContentRenderer: React.FC<HTMLContentRendererProps> = ({ payload }) => {
  return (
    <div className="prose max-w-none">
      <div dangerouslySetInnerHTML={{ __html: payload.html || '<p>Nội dung HTML trống</p>' }} />
    </div>
  );
};
